import { Injectable } from '@angular/core'

import { SerieProposal } from './serie-proposal'

@Injectable()
export class SerieProposalSerializer {
  fromJson(json: any): SerieProposal {
    const serieProposal = {
      ...json
    }

    return serieProposal
  }

  toJson(serieProposal: SerieProposal): any {
    return {
      ...serieProposal
    }
  }
}
